// extracted by mini-css-extract-plugin
export default {"restricted":"TopgearAccessGate-module_restricted__vOZZYq"};